import {
  List,
  Datagrid,
  NumberField,
  DateField,
  TextField,
  EmailField,
  ImageField,
  Edit,
  SimpleForm,
  NumberInput,
  DateInput,
  TextInput,
  ImageInput,
  Show,
  SimpleShowLayout,
  ReferenceField,
  ReferenceInput,
  Button,
  Link,
  useRecordContext,
} from 'react-admin'

import { Grid, Paper, Typography } from '@mui/material'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserProfileList = () => (
  <List queryOptions={{ meta: { isMy: true } }}>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <NumberField source="utcOffset" />
      <DateField source="birthday" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <EmailField source="email" />
      <ImageField source="avatarUrl" title="avatarUrl" />
      <TextField source="tgUsername" />
      <TextField source="tgUserId" />
      <NumberField source="tokensUsedInInterval" />
      <DateField source="currentTokensIntervalStartsAt" />
      <DateField source="tokensLastUsedAt" />
      <NumberField source="tokensUsedTotal" />
    </Datagrid>
  </List>
)

const TelegramButton = () => {
  const record = useRecordContext()
  
  if (!record?.tgUsername) {
    return null
  }

  const isConnected = !!record?.tgUserId
  
  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
      <Button 
        variant="contained" 
        color={isConnected ? "success" : "primary"}
        size="large"
        disabled={isConnected}
        sx={{ 
          mb: 3,
          px: 4,
          py: 1.5,
          borderRadius: 3,
          background: isConnected 
            ? 'linear-gradient(45deg, #4CAF50 30%, #81C784 90%)'
            : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
          boxShadow: isConnected 
            ? '0 3px 5px 2px rgba(76, 175, 80, .3)'
            : '0 3px 5px 2px rgba(33, 203, 243, .3)',
          '&:hover': {
            background: isConnected 
              ? 'linear-gradient(45deg, #4CAF50 30%, #81C784 90%)'
              : 'linear-gradient(45deg, #1976D2 30%, #1976D2 90%)',
            transform: isConnected ? 'none' : 'translateY(-2px)',
            boxShadow: isConnected 
              ? '0 3px 5px 2px rgba(76, 175, 80, .3)'
              : '0 6px 10px 2px rgba(33, 203, 243, .3)',
          },
          transition: 'all 0.3s ease-in-out'
        }}
        onClick={isConnected ? undefined : () => window.open('https://t.me/TimelyCheersBot', '_blank', 'noopener,noreferrer')}
      >
        <Typography variant="body1" sx={{ fontWeight: 600, color: 'white' }}>
          {isConnected ? '✅ Connected to Timely Cheers Bot' : '🤖 Connect to Timely Cheers Bot'}
        </Typography>
      </Button>
    </div>
  )
}

export const UserProfileEdit = () => (
  <Edit queryOptions={{ meta: { isMy: true } }} mutationOptions={{ meta: { isMy: true } }}>
    <TelegramButton />
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <ImageInput source="avatarUrl" accept="image/*">
              <ImageField source="src" title="title" />
            </ImageInput>
          </Paper>
        </Grid>
        
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextInput source="firstName" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="lastName" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DateInput source="birthday" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput source="utcOffset" fullWidth />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <TextInput source="bio" multiline rows={4} fullWidth label="Bio" />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <TextInput source="tgUsername" fullWidth />
          </Paper>
        </Grid>
      </Grid>
    </SimpleForm>
  </Edit>
)

export const UserProfileShow = () => (
  <Show queryOptions={{ meta: { isMy: true } }}>
    <SimpleShowLayout>
      <NumberField source="utcOffset" />
      <DateField source="birthday" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <EmailField source="email" />
      <ImageField source="avatarUrl" title="avatarUrl" />
      <TextField source="bio" />
      <TextField source="tgUserId" />
      <TextField source="tgUsername" />
      <NumberField source="tokensUsedInInterval" />
      <DateField source="currentTokensIntervalStartsAt" />
      <DateField source="tokensLastUsedAt" />
      <NumberField source="tokensUsedTotal" />
    </SimpleShowLayout>
  </Show>
)
